import * as React from 'react'

import AddStudents from './add_students'
import CreateAClassForm from './create_a_class_form'
import SetupInstructions from './setup_instructions'

import useModalAccessibility from '../../../Shared/hooks/useModalAccessibility'

const closeIconSrc = `${window.postbuildEnv.CDN_URL}/images/icons/close.svg`

interface CreateAClassModalProps {
  close: (event) => void;
  showSnackbar: (event) => void;
}

const CreateAClassModal = ({ close, showSnackbar, }: CreateAClassModalProps) => {
  const { modalRef, } = useModalAccessibility(close)

  const [step, setStep] = React.useState<number>(1)
  const [classroom, setClassroom] = React.useState({})

  const next = () => {
    setStep(step + 1)
  }

  const back = () => {
    setStep(step - 1)
  }

  const setStudents = (students) => {
    classroom.students = students
    setClassroom(classroom)
  }

  const renderHeader = () => {
    return (
      <div className="create-a-class-modal-header">
        <ol aria-label="Create a class steps" className="navigation">
          <li aria-current={step === 1 ? 'step' : undefined} className={step === 1 ? 'active' : ''}>1. Create a class</li>
          <li aria-current={step === 2 ? 'step' : undefined} className={step === 2 ? 'active' : ''}>2. Add students</li>
          <li aria-current={step === 3 ? 'step' : undefined} className={step === 3 ? 'active' : ''}>3. Setup instructions</li>
        </ol>
        <button className="interactive-wrapper focus-on-light" onClick={close} type="button"><img alt="Close icon" src={closeIconSrc} /></button>
      </div>
    )
  }

  const renderModalContent = () => {
    if (step === 1) {
      return <CreateAClassForm close={close} next={next} setClassroom={setClassroom} />
    } else if (step === 2) {
      return <AddStudents classroom={classroom} close={close} next={next} setStudents={setStudents} showSnackbar={showSnackbar} />
    } else {
      return <SetupInstructions back={back} classroom={classroom} close={close} />
    }
  }

  return (
    <div className="modal-container create-a-class-modal-container">
      <div className="modal-background" />
      <div
        aria-label="Create a class"
        aria-modal={true}
        className="create-a-class-modal quill-modal"
        ref={modalRef}
        role="dialog"
        tabIndex={-1}
      >
        {renderHeader()}
        {renderModalContent()}
      </div>
    </div>
  )
}

export default CreateAClassModal
